import { render, staticRenderFns } from "./HealDialog.vue?vue&type=template&id=1d958aa2&"
import script from "./HealDialog.vue?vue&type=script&lang=js&"
export * from "./HealDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports